import BentoFlatListCard from '@/components/BentoFlatListCard'
import React from 'react'

export default function OrganizationBentos() {
    return <BentoFlatListCard />
}
